// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ModalBetaConfirm = ({
  isOpen,
  onConfirm,
}) => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirm = () => {
    localStorage.setItem("sofia-magic-studio-beta-confirm", "true");
    onConfirm();
  };

  const handleClose = () => {
    navigate("/");
  };

  return (
    <Modal isOpen={isOpen}>
      <div className="w-[400px] flex flex-col z-[42] bg-white rounded-[16px]">
        <div className="px-4 py-2">
          <p className="text-[17px] font-inter-semibold leading-[28px] text-center mb-2">
            Sofia Magic Studio masih dalam tahap beta
          </p>
          <p className="text-[13px] font-inter text-[#808285]">
            Fitur ini masih bersifat beta dan eksperimental. Hasil perapihan
            foto mungkin belum selalu akurat atau stabil pada beberapa kondisi.
            Kami sangat menghargai masukan Anda untuk membantu pengembangan
            Sofia Magic Studio menjadi lebih baik.
          </p>
        </div>

        <div className="px-4 py-2 border-t border-dashed border-[#D8D8D9] flex items-start gap-2">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className="mt-1 w-4 h-4 checked:accent-[#252526]"
          />
          <p className="text-[13px] font-inter text-[#252526]">
            Saya memahami bahwa fitur ini masih dalam tahap beta.
          </p>
        </div>

        <div
          className={
            "flex items-center justify-center gap-4 px-4 pt-2 pb-4 border-t border-dashed border-[#D8D8D9]"
          }
        >
          <Button
            size="xl"
            type="secondary"
            onClick={handleClose}
            text="Kembali"
          />
          <Button
            type="primary"
            size="xl"
            text="Lanjut"
            onClick={handleConfirm}
            disabled={!isChecked}
          />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;
  return <ModalBetaConfirm isOpen={true} onConfirm={onConfirm} />;
};

export default Wrapper;
